import { SkuColorPreset } from '../../helpers/sku-labels';

/** Ink row -- readable text/stroke colours. Neutral ramp first so black and grey are always one click away. */
export const ANNOTATION_INK_COLORS: Array<string> = [
	'#000000',
	'#333333',
	'#666666',
	'#999999',
	'#ffffff',
	'#c00000',
	'#e8590c',
	'#f1a208',
	'#2f9e44',
	'#1f7fd1',
	'#6741d9',
	'#0f766e'
];

/** Tint row -- the SKU label palette, reused so annotations and SKU labels never disagree on a colour */
export const ANNOTATION_TINT_COLORS: Array<string> = [
	SkuColorPreset.White,
	SkuColorPreset.Gray,
	SkuColorPreset.LightYellow,
	SkuColorPreset.Yellow,
	SkuColorPreset.Green,
	SkuColorPreset.Blue,
	SkuColorPreset.Pink,
	SkuColorPreset.Red,
	SkuColorPreset.Orange,
	SkuColorPreset.Purple
];

export const ANNOTATION_FONT_FAMILIES: Array<string> = [
	'Arial',
	'Helvetica',
	'Inter',
	'Georgia',
	'Times New Roman',
	'Courier New',
	'Verdana',
	'Trebuchet MS'
];

/** A hex the native colour input accepts; it rejects '' and named colours and silently falls back to black */
export const toColorInputValue = (color: string | null | undefined, fallback: string): string => (
	color && /^#[0-9a-fA-F]{6}$/u.test(color) ? color : fallback
);
